import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PropertySetFilterLabelEventService {
  #eventListener = new Subject<Record<string, any>>();
  eventListener$ = this.#eventListener.asObservable();

  triggerEvent(event: Record<string, any>) {
    this.#eventListener.next(event);
  }
}
